import { useTranslation } from "react-i18next"
import { 
  AppBar,
  Toolbar,
  IconButton,
  Dialog,
  Typography,} from "@material-ui/core";
import { Close } from "@material-ui/icons";

const DeviceSetupFormHeader = ({style, groupData, handleClose}) => {
    var {t} = useTranslation();

    return (<>
        <AppBar className={style.appBar}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
                <Close />
                </IconButton>
                <Typography variant="h6" className={style.title}>
                {t("devices.setUp.title", { groupName: groupData?.name })}
                </Typography>
            </Toolbar>
        </AppBar>
    </>)
};
export default DeviceSetupFormHeader;
